import { render, staticRenderFns } from "./MCP.vue?vue&type=template&id=c1cd4e08&scoped=true&"
import script from "./MCP.vue?vue&type=script&lang=js&"
export * from "./MCP.vue?vue&type=script&lang=js&"
import style0 from "./MCP.vue?vue&type=style&index=0&id=c1cd4e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cd4e08",
  null
  
)

export default component.exports